/**
 * DemoBadge — small ribbon shown on seeded demonstration profiles.
 *
 * Flagged by `is_demo` on the user row or `demo_badge` on the profile row.
 * The badge makes it obvious a profile is a showcase example, so visitors
 * never confuse it with a live member of the community.
 */
export default function DemoBadge({ className = "", size = "md" }) {
  const sizeCls =
    size === "sm"
      ? "text-[9px] px-2 py-0.5 gap-1"
      : "text-[10px] px-2.5 py-1 gap-1.5";
  return (
    <span
      className={`inline-flex items-center ${sizeCls} rounded-full bg-[#1A1A1A]/85 backdrop-blur text-[#E6C29A] font-semibold uppercase tracking-[0.14em] shadow-[0_4px_14px_-6px_rgba(0,0,0,0.35)] ${className}`}
      data-testid="demo-badge"
      title="Profil démonstration — exemple non-contactable"
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#C68E59]" />
      Démo
    </span>
  );
}
